import { render, staticRenderFns } from "./ViberIncomingTariffs.vue?vue&type=template&id=73764e95&"
import script from "./ViberIncomingTariffs.vue?vue&type=script&lang=ts&"
export * from "./ViberIncomingTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports